<div class="card">
    <p-messages severity="info">
        <ng-template pTemplate>
            <div>
                User(s) not automatically receiving the text notifications?
                <ol>
                    <li>
                        Verify mobile number is correct in eFAACT Central-all users (this information is imported from
                        QuickBooks or GovConPay).
                    </li>
                    <li>
                        Have end user text the word START to 888-871-5967.
                    </li>
                </ol>
            </div>
        </ng-template>
    </p-messages>

    <form [formGroup]="filterFormGroup" #filterForm="ngForm" id="filterForm">
        <p-toolbar>
            <p-floatLabel variant="on">
                <p-calendar formControlName="startDate" appendTo="body" selectionMode="single" [monthNavigator]="true"
                    [yearNavigator]="true" [yearRange]="
                    moment().add(-10, 'year').format('YYYY') +
                    ':' +
                    moment().add(10, 'year').format('YYYY')
                "></p-calendar>
                <label for="float-dd">Start Date</label>
            </p-floatLabel>
            <p-floatLabel variant="on">
                <p-calendar formControlName="endDate" appendTo="body" selectionMode="single" [monthNavigator]="true"
                    [yearNavigator]="true" [yearRange]="
                    moment().add(-10, 'year').format('YYYY') +
                    ':' +
                    moment().add(10, 'year').format('YYYY')
                "></p-calendar>
                <label for="float-dd">End Date</label>
            </p-floatLabel>
            <div>
                <button type="button" pButton pRipple icon="pi pi-download" pTooltip="Download"
                    class="p-button-secondary" (click)="this.dataTable.exportCSV()"></button>
            </div>
        </p-toolbar>
    </form>
    <div style="height: 75vh">
        <p-table stripedRows #dataTable [value]="items" [columns]="cols" scrollHeight="65vh" [scrollable]="true" sortMode="multiple" dataKey="id">
            <ng-template pTemplate="emptymessage">
                <tr class="empty-table">
                    <td [attr.colspan]="numCols" style="text-align: center">
                        <div class="tabulator-placeholder">
                            <span> No Data Available </span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template #header let-columns>
                <tr>
                    <!-- Type -->
                    <th pSortableColumn="Type">
                        Type
                        <p-sortIcon
                            title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                            field="Type" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        <p-columnFilter field="Type" matchMode="in" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false" class="ml-auto">
                            <ng-template #filter let-value let-filter="filterCallback">
                                <p-multiSelect #messageTypeFilter fluid
                                    defaultLabel="Filter" maxSelectedLabels="1" appendTo="body" [options]="messageTypes"
                                    [filter]="true" [ngModel]="value" (ngModelChange)="filter($event)"></p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <!-- MessageDate -->
                    <th pSortableColumn="MessageDate">
                        Message Date
                        <p-sortIcon
                            title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                            field="MessageDate" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Recipient -->
                    <th pSortableColumn="Recipient">
                        Recipient
                        <p-sortIcon
                            title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                            field="Recipient" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        <p-columnFilter type="text" matchMode="contains" field="Recipient" display="menu" class="ml-auto" />
                    </th>
                    <!-- Subject -->
                    <th pSortableColumn="Subject">
                        Subject
                        <p-sortIcon
                            title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                            field="Subject" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        <p-columnFilter type="text" matchMode="contains" field="Subject" display="menu" class="ml-auto" />
                    </th>
                    <!-- Message -->
                    <th pSortableColumn="Message">
                        Message
                        <p-sortIcon
                            title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                            field="Message" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Status -->
                    <th pSortableColumn="Status">
                        Status
                        <p-sortIcon
                            title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                            field="Status" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr class="p-datatable-row">
                    <!-- Type -->
                    <td [attr.title]="rowData.Type"
                        class="p-datatable-cell small-cell">
                        {{ rowData.Type }}
                    </td>
                    <!-- MessageDate -->
                    <td [attr.title]="rowData.MessageDate"
                        class="p-datatable-cell small-cell">
                        {{ moment(rowData.MessageDate).format('L') }}&nbsp;{{
                        moment(rowData.MessageDate).format('LT')
                        }}
                    </td>
                    <!-- Recipient -->
                    <td [attr.title]="rowData.Recipient"
                        class="p-datatable-cell small-cell">
                        {{ rowData.Recipient }}
                    </td>
                    <!-- Subject -->
                    <td [attr.title]="rowData.Subject"
                        class="p-datatable-cell large-cell">
                        {{ rowData.Subject }}
                    </td>
                    <!-- Message -->
                    <td [attr.title]="rowData.Message"
                        class="p-datatable-cell large-cell">
                        {{ rowData.Message }}
                    </td>
                    <!-- Status -->
                    <td [attr.title]="rowData.Status"
                        class="p-datatable-cell tiny-cell">
                        {{ rowData.Status }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
